import SharedLocale from '../shared/l10n';
import SettingLocale from '../support/l10n';
import AuthLocale from '../auth/l10n';
import NotificationLocale from '../notification/l10n';

export default {
    fa: {   ...SharedLocale.fa, ...SettingLocale.fa,  ...AuthLocale.fa, ...NotificationLocale.fa },
    en: { ...SharedLocale.en, },
    es: {   ...SharedLocale.es, },
};